import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {CmsConfig, ConfigModule, I18nModule, UrlModule} from '@spartacus/core';
import {CustomFacetListModule} from './custom-facet-list/custom-facet-list.module';
import {CustomProductFacetNavigationComponent} from './custom-product-facet-navigation.component';
import {IconModule} from '@spartacus/storefront';
import {CustomActiveFacetsModule} from './active-facets/custom-active-facets.module';
import {RouterModule} from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    CustomFacetListModule,
    CustomActiveFacetsModule,
    IconModule,
    UrlModule,
    RouterModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductRefinementComponent: {
          component: CustomProductFacetNavigationComponent,
        },
      },
    } as CmsConfig),
  ],
  declarations: [CustomProductFacetNavigationComponent],
  exports: [CustomProductFacetNavigationComponent, ],
})
export class CustomProductFacetNavigationModule {
}
